import React, { useEffect } from 'react';
import qs from 'qs';
import { useHistory, useLocation } from 'react-router-dom';

import { V2_ROUTE_PAGES } from '@aware/v2-routes/constants';
import V2SettingsIframe from '@aware/common/v2-settings-iframe';
import { replaceCancelButtonAction } from './helpers';

const NewStudentForm = () => {
  const history = useHistory();
  const location = useLocation();

  // This should just refresh the page
  const redirectFn = () => {
    history.push('new-student-form');
  };

  useEffect(() => {
    window.top.newFormCallbackFn = (newFormId, campusId) => {
      history.push(
        `${V2_ROUTE_PAGES.studentForms}/${newFormId}${qs.stringify(
          { campusId: campusId === 0 ? undefined : campusId },
          { addQueryPrefix: true }
        )}`
      );
    };

    return () => delete window.top.newFormCallbackFn;
  }, [history]);

  return (
    <V2SettingsIframe
      iframeSrc="/aware/?embed=1&detailsSrc=/aware/manage/forms/newform.aspx?embed=1"
      title="New Student Form"
      key={location.key}
      onLoadCallback={iframe => replaceCancelButtonAction({ iframe, redirectFn })}
    />
  );
};

export default NewStudentForm;
